/**
 * Facility API Service
 */

import apiClient from './apiClient';
import {
  FacilityDTO,
  CreateFacilityRequest,
  PageResponse,
} from '../types/facility.types';

const BASE_PATH = '/v1/facilities';

class FacilityService {
  async createFacility(request: CreateFacilityRequest): Promise<FacilityDTO> {
    const response = await apiClient.post<FacilityDTO>(BASE_PATH, request);
    return response.data;
  }

  async getFacilityById(id: string): Promise<FacilityDTO> {
    const response = await apiClient.get<FacilityDTO>(`${BASE_PATH}/${id}`);
    return response.data;
  }

  async getFacilityByCode(code: string): Promise<FacilityDTO> {
    const response = await apiClient.get<FacilityDTO>(`${BASE_PATH}/code/${code}`);
    return response.data;
  }

  async getAllFacilities(page: number = 0, size: number = 20): Promise<PageResponse<FacilityDTO>> {
    const response = await apiClient.get<PageResponse<FacilityDTO>>(BASE_PATH, {
      params: { page, size, sort: 'createdAt' },
    });
    return response.data;
  }

  async getFacilitiesByClient(clientId: string): Promise<FacilityDTO[]> {
    const response = await apiClient.get<FacilityDTO[]>(`${BASE_PATH}/client/${clientId}`);
    return response.data;
  }

  async getActiveFacilities(page: number = 0, size: number = 20): Promise<PageResponse<FacilityDTO>> {
    const response = await apiClient.get<PageResponse<FacilityDTO>>(`${BASE_PATH}/active`, {
      params: { page, size, sort: 'name' },
    });
    return response.data;
  }

  async updateFacility(id: string, data: Partial<FacilityDTO>): Promise<FacilityDTO> {
    const response = await apiClient.put<FacilityDTO>(`${BASE_PATH}/${id}`, data);
    return response.data;
  }

  async deleteFacility(id: string): Promise<void> {
    await apiClient.delete(`${BASE_PATH}/${id}`);
  }
}

export default new FacilityService();
